import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../utils/api';

const BASE_URL = '/api';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [branding, setBranding] = useState(null); // null = yükleniyor
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/public-settings`)
      .then((r) => r.ok ? r.json() : {})
      .then((data) => {
        setBranding(data);
        // Favicon + title
        const name = data.appName || 'Ozon WMS';
        document.title = name;
        const favicon = document.getElementById('favicon');
        if (favicon && data.logoDataUrl) {
          favicon.href = data.logoDataUrl;
        }
      })
      .catch(() => setBranding({}));
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await api.login(username, password);
      localStorage.setItem('ozon_token', data.token);
      localStorage.setItem('ozon_username', data.username);
      // Marka ayarlarını cache'e yaz — Layout hemen okusun
      if (branding) localStorage.setItem('ozon_branding', JSON.stringify(branding));
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  const appName  = branding?.appName    || 'Ozon WMS';
  const appSub   = branding?.appSubtitle || 'FBS Sipariş Yönetim Sistemi';
  const logoUrl  = branding?.logoDataUrl || '';

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo / başlık */}
        <div className="text-center mb-8">
          {logoUrl ? (
            <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-800 rounded-2xl mb-4 overflow-hidden border border-slate-700">
              <img src={logoUrl} alt="logo" className="w-12 h-12 object-contain" />
            </div>
          ) : (
            <div className="inline-flex items-center justify-center w-14 h-14 bg-blue-600 rounded-2xl mb-4">
              <span className="text-2xl">📦</span>
            </div>
          )}
          <h1 className="text-2xl font-bold text-white">{appName}</h1>
          <p className="text-slate-400 text-sm mt-1">{appSub}</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-slate-800 border border-slate-700 rounded-2xl p-7 space-y-4">
          <div>
            <label className="block text-xs font-medium text-slate-400 mb-1.5">Kullanıcı Adı</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              required
              autoFocus
              className="w-full bg-slate-700 border border-slate-600 text-white placeholder-slate-500 rounded-lg px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-400 mb-1.5">Şifre</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              className="w-full bg-slate-700 border border-slate-600 text-white placeholder-slate-500 rounded-lg px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {error && (
            <div className="bg-red-900/40 border border-red-800 text-red-400 text-sm px-3.5 py-2.5 rounded-lg">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white font-medium py-2.5 rounded-lg text-sm transition-colors mt-2"
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>

        <p className="text-center text-slate-600 text-xs mt-6">
          {appName} — Yetkisiz erişim yasaktır
        </p>
      </div>
    </div>
  );
}
